export default __webpack_public_path__ + "public/icons/manageInTestCycle.png?017f682a4f6b3629672f61f589d9569d";